import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import { WaitlistStatusBar } from './components/WaitlistStatusBar';
import FeedbackForm from './components/FeedbackForm';
import { Footer } from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Demo from './pages/Demo';
import Progress from './pages/Progress';
import QA from './pages/QA';
import Privacy from './pages/Privacy';
import { usePageTracking } from './lib/analytics';

// Wrapper component to handle analytics
function AppContent() {
  usePageTracking();
  
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navigation />
      <WaitlistStatusBar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/qa" element={<QA />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </main>
      <FeedbackForm />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;